<div style="text-align: right; margin-bottom: -1.375rem;">
  <span (click)="closeDialog()" class="closeButton">&#10005;</span>
</div>
<div style="margin-top: 2.188rem; text-align: center;">
  <span style="color: #005984; font-size: 1.5rem;">Select Gas project type</span>
</div>
<div style="margin-top: 2.5rem;">
  <mat-radio-group [(ngModel)]="gasProjectSelection" style="display: grid; justify-content: center;">
    <mat-radio-button disabled color="primary" [value]="'Funding'" style="display: block;">
      <span>Funding</span>
    </mat-radio-button>
    <mat-radio-button color="primary" [value]="'Charging'" style="display: block; margin-top: 1.875rem;">
      <span>Charging</span>
    </mat-radio-button>
  </mat-radio-group>
</div>
<div style="margin-top: 2rem; text-align: center; margin-left: 0.3rem;">
  <button (click)="goToProjectScreen()" class="okButton" [disabled]="!gasProjectSelection" [class.buttonDisabled]="!gasProjectSelection"
    [class.buttonLoading]="movingToProjectScreen">
    <span *ngIf="!movingToProjectScreen" class="buttonText">GET STARTED</span>
    <div *ngIf="movingToProjectScreen" class="dot-spin" style="margin: auto"></div>
  </button>
</div>